import { render, staticRenderFns } from "./TkDownArrow.vue?vue&type=template&id=6febb0eb&"
import script from "./TkDownArrow.vue?vue&type=script&lang=js&"
export * from "./TkDownArrow.vue?vue&type=script&lang=js&"
import style0 from "./TkDownArrow.vue?vue&type=style&index=0&id=6febb0eb&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports